export default {
  loginUserInfo: state => state.loginUserInfo,
  sellerData: state => state.sellerData,
  fistActIndex: state => state.fistActIndex,
  activeMenu: state => state.activeMenu,
  fistMenuList: state => state.fistMenuList,
  childMenuList: state => state.childMenuList,
  scaleValue: state => state.scaleValue,
  isIframe: state => state.isIframe,
}